import React from "react";

import { LocationProps } from "../../interfaces/locations/location-interface";
import { InStoreTile } from "./in-store-tile";
import styles from "./instore.module.scss";

type Props = {
    locations: Array<LocationProps>;
};

export const InStoreList: React.FC<Props> = (props: Props) => {
    const { locations } = props;
    return (
        <div className={styles.instoreListContainer}>
            {locations.map((location) => (
                <InStoreTile key={location.id} location={location} />
            ))}
        </div>
    );
};
